module.exports = __webpack_public_path__ + "media/images/sampleBet__deco-c4c26211866102f870c9492abd77d516.png";